import { render, staticRenderFns } from "./GenerationStatusBanner.vue?vue&type=template&id=81fe59da&scoped=true"
import script from "./GenerationStatusBanner.vue?vue&type=script&lang=js"
export * from "./GenerationStatusBanner.vue?vue&type=script&lang=js"
import style0 from "./GenerationStatusBanner.vue?vue&type=style&index=0&id=81fe59da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fe59da",
  null
  
)

export default component.exports